import React, { useCallback, useEffect, useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Text, useMediaQuery,
} from "@chakra-ui/react";

import APButton from "./APButton";
import { useSettingsContext } from "../contexts/SettingsContext";
import APSwitch from "./APSwitch";
import { HiOutlineArrowRight } from "react-icons/hi";
import { MdOutlineClose } from "react-icons/md";
import APMainButton from "./APMainButton";
import {FormattedMessage} from "react-intl";

interface SettingsModalProps {
  sdk: any;
}

export default function SettingsModal({ sdk }: SettingsModalProps) {
  const {
    settingModalOpen,
    setSettingModalOpen,
    setProfileOpen,
    setDefaultProfileTab,
  } = useSettingsContext();
  const [soundChecked, setSoundChecked] = useState(false);
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");

  const fetchSettings = useCallback(async () => {
    if (sdk) {
      const data = await sdk.getDataManager().getSettings();
      if (data && data.soundEffects) {
        setSoundChecked(data.soundEffects);
      }
    }
  }, [sdk]);

  useEffect(() => {
    fetchSettings();
  }, [sdk]);

  const handleSoundChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSoundChecked(event.target.checked);
    if (sdk) {
      const data = await sdk.getDataManager().saveSettings({
        data: {
          soundEffects: event.target.checked,
        },
      });
    }
  };

  const handleOpenProfile = () => {
    setSettingModalOpen(false);
    setProfileOpen(true);
    setDefaultProfileTab(1);
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={settingModalOpen}
        onClose={() => setSettingModalOpen(false)}
      >
        <ModalOverlay>
          <ModalContent
            sx={{
              p: 0,
              borderTopRadius: "1.5rem",
              position: "relative",
              width: "calc(100% - 48px)",
              maxWidth: isLargeScreen ? "35rem" : "28rem",
              mt: isLargeScreen ? "4.75rem" : "3.75rem"
            }}
          >
            <APMainButton
              sx={{
                position: "absolute",
                right: isLargeScreen ? -5 : -4,
                top: isLargeScreen ? -5 : -4,
                width: isLargeScreen ? "3.8rem" : "3rem",
                height: isLargeScreen ? "3.8rem" : "3rem",
              }}
              onClick={() => setSettingModalOpen(false)}
            >
              <MdOutlineClose
                color="#fff"
                width={isLargeScreen ? "0.95rem" : "0.75rem"}
                height={isLargeScreen ? "0.95rem" : "0.75rem"}
                fontSize={isLargeScreen ? "2.5rem" : "2rem"}
              />
            </APMainButton>
            <ModalHeader
              sx={{
                p: isLargeScreen ? "1.9rem" : "1.5rem",
                bg: "#f5f3ef",
                borderTopRadius: isLargeScreen ? "1.9rem" : "1.5rem"
              }}
            >
              <Box sx={{}}>
                <Text
                  textAlign={"center"}
                  fontFamily={"ChromaticaBold"}
                  fontSize={isLargeScreen ? "1.4rem" : "1.125rem"}
                  lineHeight={1.5}
                >
                  <FormattedMessage id="settings" defaultMessage={`Paramètres`}/>
                </Text>
              </Box>
            </ModalHeader>
            <ModalBody sx={{ p: isLargeScreen ? "1.9rem" : "1.5rem" }}>
              <Box display="flex" flexDir={"column"}>
                <Text
                  fontFamily={"ChromaticaBold"}
                  fontSize={isLargeScreen ? "1.26rem" : "1rem"}
                  color="gray.550"
                >
                  <FormattedMessage id="personalization" defaultMessage={`Personnalisation`}/>
                </Text>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    mt: isLargeScreen ? 2.5 : 2,
                  }}
                >
                  <Button
                    isFullWidth
                    sx={{ bg: "#f5f3ef", height: isLargeScreen ? "4.4rem" : "3.5rem" }}
                    onClick={handleOpenProfile}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Text
                        fontFamily={"ChromaticaBold"}
                        fontSize={isLargeScreen ? "1.26rem" : "1rem"}
                        lineHeight={1.5}
                      >
                        <FormattedMessage id="change-the-wallpaper" defaultMessage={`Modifier le fond d’écran`}/>
                      </Text>
                      <HiOutlineArrowRight size={isLargeScreen ? 20 : 16}/>
                    </Box>
                  </Button>
                </Box>
              </Box>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      </Modal>
    </>
  );
}
